import * as React from "react";
import { useCommonHooks, useEditRouteParams } from "../../hooks";
import { useQuery } from "react-query";
import { ERoutes } from "../../AppRouter";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { BackButton, PageBase } from "../../components";
import FunctionDetailPanel from "./FunctionDetailPanel";

export interface IFunctionItemPageProps {}

export const FunctionItemPage: React.FunctionComponent<
  IFunctionItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["function-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.functions.getDisplayName(+id);
      }
      return t("NewFunction");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      { text: t("FunctionAndDirectorList"), route: ERoutes.functions },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.functions}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.functions} />
        <Tab
          id="details"
          title={t("Details")}
          panel={<FunctionDetailPanel functionId={+id} />}
        />
      </Tabs>
    </PageBase>
  );
};
export default FunctionItemPage;
